module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crew_right"
  }, [_c('div', {
    staticClass: "conInner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "lm-con"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "msgbox"
  }, [_c('p', [_vm._v("最多上传10张")]), _vm._v(" "), _c('div', {
    staticClass: "img_box"
  }, [_vm._l((_vm.goodsImg), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "demo-upload-list"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "demo-upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(item)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemoveList(index)
        }
      }
    })], 1)])
  }), _vm._v(" "), (_vm.goodsImg.length < 10) ? _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px"
    },
    attrs: {
      "show-upload-list": false,
      "on-exceeded-size": _vm.handleMaxSize,
      "on-success": _vm.handleSuccessListGood,
      "on-format-error": _vm.handleFormatError,
      "before-upload": _vm.handleBeforeUpload,
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "headers": {
        "Auth-Token": _vm.upHeaders
      },
      "multiple": "",
      "type": "drag",
      "action": _vm.UploadUrl()
    }
  }, [_c('div', {
    staticStyle: {
      "width": "150px",
      "height": "150px",
      "line-height": "150px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "regis_box"
  }, [_c('input', {
    staticClass: "regis_ent",
    attrs: {
      "type": "button",
      "value": "立即保存",
      "id": "discussBtn"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit(1)
      }
    }
  })])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "图片预览"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [(_vm.visible) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.showImageUrl
    }
  }) : _vm._e()])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data"
  }, [_c('h2', [_vm._v("商品图管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a056a16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/my-data/right/uploadShopImg.vue
// module id = 1557
// module chunks = 1